<template>
  <div class="content-survey-impact">

    <div class="content-survey-impact__header">
      <h3>{{ title }}</h3>

      <div class="impact-header__controls">
        <select-filter-alt v-model="selectedCategory" :selections="categories" />
      </div>

      <div v-if="currentCommentary" class="impact-header__commentary">
        <p class="text-legend text--darkgrey">
          {{ currentCommentary }}
        </p>
      </div>
    </div>

    <!-- chart here -->
    <div class="content-survey-impact__chart">
      <BarChartX :type.sync="selectedCategory" @data-sanitized="loadData" />
    </div>
  </div>
</template>

<script>
import SelectFilterAlt from '@/components/ui/SelectFilterAlt.vue';

export default {
  name: 'SurveyImpact',
  components: {
    SelectFilterAlt,
    BarChartX: () => import('@/components/content/chapter2/charts/BarChartX.vue'),
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadedData: [],
      selectedCategory: '',
    };
  },
  computed: {
    categories() {
      return this.loadedData.map((d) => d.type);
    },
    currentCommentary() {
      const selectedSet = this.loadedData.find((item) => item.type === this.selectedCategory);
      return selectedSet ? selectedSet.commentary : '';
    },
  },
  methods: {
    loadData(data) {
      // get unique objects by "type" prop
      this.loadedData = [...new Map(data.map(({ type, commentary }) => [type, { type, commentary }])).values()];
    },
  },
};
</script>

<style lang="scss" scoped>
.content-survey-impact {
  padding: 60px 0;

  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }
  
  &__header {
    margin-bottom: 30px;

    .impact-header__controls {
      margin-bottom: 20px;
    }

    .impact-header__commentary {
      background-color: #f0f0f0;
      border-radius: 5px;
      padding: 10px;

      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
